import React from 'react';
import { log } from './LogStreamTable';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { darcula } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

export const cleanJson = (
  message: log['message']['message']
): log['message']['message'] => {
  if (typeof message !== 'object') return message;
  const m = { ...message };
  if (m.mail?.sourceArn) delete m.mail.sourceArn;
  if (m.mail?.sendingAccountId) delete m.mail.sendingAccountId;
  if (m.mail?.tags) {
    const tags: { [key: string]: string[] } = {};
    Object.keys(m.mail.tags).forEach((k) => {
      tags[k.replace('ses:', '')] = m.mail?.tags?.[k] ?? [];
    });
    m.mail.tags = tags;
  }
  if (m.mail?.tags?.operation) delete m.mail.tags.operation;
  if (m.mail?.tags?.['configuration-set'])
    delete m.mail.tags['configuration-set'];
  if (m.mail?.tags?.['source-ip']) delete m.mail.tags['source-ip'];
  if (m.mail?.tags?.['caller-identity']) delete m.mail.tags['caller-identity'];

  return m;
};

const JsonDisplay = ({
  json
}: {
  json: string | Record<string, unknown>;
}): JSX.Element => {
  return (
    <div style={{ position: 'relative' }}>
      <SyntaxHighlighter
        language="json"
        style={darcula}
        customStyle={{
          padding: '10px',
          fontSize: '10px'
        }}
      >
        {JSON.stringify(cleanJson(json), null, 2)}
      </SyntaxHighlighter>
      <Button
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px'
        }}
        icon={<CopyOutlined />}
        onClick={() =>
          navigator.clipboard.writeText(JSON.stringify(json, null, 2))
        }
      >
        Copy Log
      </Button>
    </div>
  );
};

export default JsonDisplay;
